import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=4e72b443&scoped=true"
import script from "./VerifyIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72b443",
  null
  
)

export default component.exports